<div class="phone_btn" [ngClass]="{round:round}" [style.background]="background">
  <img class="abs_center phone" [ngClass]="{phone_hangup:round}" src="assets/images/phone_hungup.svg">
</div>
